import React, { useContext } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import { Context as AuthContext, Store as AuthStore } from "./context/Auth";
import { Store as IntegrationsStore } from "./context/Integrations";

import Signup from "./pages/Signup";
import Login from "./pages/Login";
import GoogleCallback from "./pages/GoogleCallback";
import Dashboard from "./pages/Dashboard";

import theme from "./theme";

const AppRoutes = () => {
    const { state } = useContext(AuthContext);

    return (
        <Routes>
            {/* Redirect from root path to /signup */}
            <Route path="/" element={<Navigate to="/dashboard" />} />

            <Route
                path="/login"
                element={state.user ? <Navigate to="/dashboard" /> : <Login />}
            />

            {/* Conditionally render based on auth state */}
            <Route
                path="/signup"
                element={state.user ? <Navigate to="/dashboard" /> : <Signup />}
            />

            <Route path="/google/callback" element={<GoogleCallback />} />

            <Route path="/dashboard/*" element={<Dashboard />} />

            {/* Add other routes here */}
        </Routes>
    );
};

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <AuthStore>
                    <IntegrationsStore>
                        <AppRoutes />
                    </IntegrationsStore>
                </AuthStore>
            </Router>
        </ThemeProvider>
    );
}

export default App;
